import { render, staticRenderFns } from "./RemoveBlock.vue?vue&type=template&id=e451bc20"
import script from "./RemoveBlock.vue?vue&type=script&lang=js"
export * from "./RemoveBlock.vue?vue&type=script&lang=js"
import style0 from "./RemoveBlock.vue?vue&type=style&index=0&id=e451bc20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports